<template>
  <div>
    <div v-if="detailDevisCommande"
      class="is-flex pdt-20px columns is-multiline">
      <div class="corps column is-10">
        <user-warning-message
          :users="[
            { id: devisCommande.commercialId, msg: 'utilisateur.warning.commercialArchive' },
            { id: devisCommande.assistantId, msg: 'utilisateur.warning.assistantArchive' },
          ]"/>
        <contact-warning-message :contacts="archivedContacts"/>
        <div class="steps-detail">
          <dot-steps
            :steps="commandSteps"
            :current-step="detailDevisCommande.etat"/>
        </div>
        <commande-information :commande="detailDevisCommande"
          :commandeDetail="devisCommande"/>
      </div>
      <div class="column is-2">
        <div class="sticky-20px">
          <dots-menu :steps="steps">
          </dots-menu>
          <information-create-update-user :data="devisCommande">
          </information-create-update-user>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DotsMenu from '@/components/general/dotsMenu';
import DotSteps from '@/components/general/dotSteps';
import commandeInformation from '@/components/baux/commandeAchat/commandeInformation';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import contactWarningMessage from '@/components/commun/tiers/contact/contactWarningMessage';
import getArchivedContactsFromIntervenants from '@/services/contact/getArchivedContactsFromIntervenants';

export default {
  components: {
    DotSteps,
    DotsMenu,
    commandeInformation,
    InformationCreateUpdateUser,
    userWarningMessage,
    contactWarningMessage,
  },
  props: {
    detailDevisCommande: Object,
    devisCommande: Object,
  },
  data() {
    return {
      commandSteps: [
        'Brouillon',
        'Enregistre',
        'Facture',
      ],
      steps: [
        {
          name: this.$i18n.t('detailCommandeBailleur.anchor.title'),
          ref: '#detail-command',
          active: true,
        },
        {
          name: this.$i18n.t('detailCommandeBailleur.anchor.echeancierFacturation'),
          ref: '#detail-schedule',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommandeBailleur.anchor.piecesJointes'),
          ref: '#attachments',
          active: false,
        },
      ],
      archivedContacts: [],
    };
  },
  mounted() {
    this.archivedContacts = getArchivedContactsFromIntervenants(this.devisCommande.intervenants);
  },
};
</script>
